export default '/build/a88dafca.svg'